export class MapAccommodationMarkersLoadError extends Error {
  readonly cause: unknown

  constructor(cause: unknown) {
    super('Error loading map accommodation markers')
    this.name = 'MapAccommodationMarkersLoadError'
    this.cause = cause
  }
}
